import React from 'react';
import moment from 'moment';
import { IMSubscriptionPlan } from '@/types';
import { priceView } from '@/utils/utils';

interface InvoiceSummaryProps {
  invoicePreview: any;
  invoicePreviewNewPlan?: any;
  selectedPlan: IMSubscriptionPlan | null;
  futureInvoice?: any;
  trialEndDate?: number | null;
  isMobile?: boolean;
  discountPercent?: number;
}

const InvoiceSummary: React.FC<InvoiceSummaryProps> = ({
  invoicePreview,
  invoicePreviewNewPlan,
  selectedPlan,
  futureInvoice,
  trialEndDate,
  isMobile = false,
  discountPercent,
}) => {
  const mobileClass = "mb-5 last:mb-0";
  const desktopClass = "md:mb-6 xl:mb-8 last:mb-0";
  const spacingClass = isMobile ? mobileClass : desktopClass;
  const textSizeClass = isMobile ? "text-[13px]/[1.2]" : "md:text-[13px]/[1.2] xl:text-base";
  const trialPeriodDays = Math.ceil(moment(trialEndDate).diff(moment(), 'hours') / 24);
  const nextPaymentDate = invoicePreview?.next_payment_attempt ? moment.unix(invoicePreview.next_payment_attempt) : null;

  let price = selectedPlan?.flatFee;

  if (price && discountPercent) {
    price = price - price / 100 * discountPercent;
  }

  return (
    <>
      <div className={`flex justify-between gap-3 ${textSizeClass} font-medium ${isMobile ? mobileClass : "md:mb-6 xl:mb-8 last:mb-0"}`}>
        <span>{invoicePreviewNewPlan?.name}</span>
        <span>
          <span>{selectedPlan?.flatFee ? priceView(price, 'USD') : '$0.00'}</span>
          <span>/{selectedPlan?.period === 'month' ? 'mo' : 'yr'}</span>
        </span>
      </div>

      <div className={`${textSizeClass} font-medium mt-auto lg:mb-20`}>
        {/*{(typeof invoicePreview?.tax !== 'undefined' || (futureInvoice && trialEndDate && typeof futureInvoice?.tax !== 'undefined')) && (*/}
        {/*  <div className={`flex justify-between gap-3 ${spacingClass}`}>*/}
        {/*    <span>Tax</span>*/}
        {/*    <span>{priceView(((invoicePreview?.tax ?? futureInvoice?.tax ?? 0)) / 100, 'USD')}</span>*/}
        {/*  </div>*/}
        {/*)}*/}
        {/*<div className={`flex justify-between gap-3 ${spacingClass}`}>*/}
        {/*  <span>Total</span>*/}
        {/*  <span>{priceView(invoicePreview.total / 100, 'USD')}</span>*/}
        {/*</div>*/}
        {invoicePreview.starting_balance !== 0 && (
          <div className={`flex justify-between gap-3 ${spacingClass}`}>
            <span>Your balance</span>
            <span>{priceView(Math.abs(invoicePreview.starting_balance) / 100, 'USD')}</span>
          </div>
        )}
        {(futureInvoice && trialEndDate) ? (
          <>
            {/* <div className={`flex justify-between gap-3 ${spacingClass}`}>
              <span>Tax</span>
              <span>{priceView(futureInvoice?.tax / 100, 'USD')}</span>
            </div> */}
            <div className={`flex justify-between gap-3 ${spacingClass}`}>
              <span>Due {moment(trialEndDate).format('MMM D')}</span>
              <span>{priceView(futureInvoice.amount_due / 100, 'USD')}</span>
            </div>
            <div className={`flex justify-between gap-3 ${spacingClass}`}>
              <span>Due now</span>
              <span className="flex flex-col text-right">
                <span>{priceView(invoicePreview.amount_due / 100, 'USD')}</span>
                <span className="md:text-[11px] lg:text-[13px]/[1.2] text-[#19A28B] mt-1.5 lg:mt-1">{trialPeriodDays} days free</span>
              </span>
            </div>
          </>
        ) : (
          <>
            {/* <div className={`flex justify-between gap-3 ${spacingClass}`}>
              <span>Tax</span>
              <span>{priceView(invoicePreview?.tax / 100, 'USD')}</span>
            </div> */}
            <div className={`flex justify-between gap-3 ${spacingClass}`}>
              <span>{nextPaymentDate ? `Due ${nextPaymentDate.format('MMM D')}` : 'Due now'}</span>
              <span>{priceView(invoicePreview.amount_due / 100, 'USD')}</span>
            </div>
          </>
        )}
        {invoicePreview.ending_balance !== 0 && (
          <div className={spacingClass}>
            <div className="flex justify-between gap-3">
              <span>Your new balance</span>
              <span>{priceView(Math.abs(invoicePreview.ending_balance) / 100, 'USD')}</span>
            </div>
            <div className="text-[11px]/[1.4] mt-1">(will be applied to your future invoices)</div>
          </div>
        )}
      </div>
    </>
  );
};

export default InvoiceSummary;
